module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "otherbooks",
    attrs: {
      "id": "adc"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Also by Robert K. Wilcox")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('em', [_vm._v("Black Aces High")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Wings of Fury")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Scream of Eagles")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Japan’s Secret War")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Fatal Glimpse")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("Shroud")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("The Mysterious Deaths at Ann Arbor")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae27686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312322496_epub_adc_r1.vue
// module id = 63
// module chunks = 0